var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-default grid-history pull-right",
        attrs: { type: "button" },
        on: { click: _vm.showHistory }
      },
      [
        _c("i", { staticClass: "fa fa-history" }),
        _vm._v(
          "\n    " +
            _vm._s(_vm.translate("entity_logger.modal.show_button_title")) +
            "\n  "
        )
      ]
    ),
    _vm._v(" "),
    _vm.isVisible
      ? _c(
          "div",
          {
            staticClass: "bootbox modal fade history-modal in",
            attrs: { tabindex: "-1", role: "dialog" }
          },
          [
            _c("div", { staticClass: "modal-dialog modal-lg" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "bootbox-close-button close",
                      attrs: { type: "button" },
                      on: { click: _vm.hideHistory }
                    },
                    [_vm._v("\n            ×\n          ")]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.translate("entity_logger.modal.title")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "bootbox-body" },
                    [
                      _vm.loading ? _c("ring-loader") : _vm._e(),
                      _vm._v(" "),
                      _vm.historyItems.length && !_vm.loading
                        ? _c("div", { staticClass: "table-responsive" }, [
                            _c(
                              "table",
                              { staticClass: "table table-striped" },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "entity_logger.list.date"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "entity_logger.list.user"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "entity_logger.list.type"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "entity_logger.list.entity"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translate(
                                            "entity_logger.list.data_changes"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.historyItems, function(
                                    item,
                                    itemIndex
                                  ) {
                                    return _c("tr", { key: itemIndex }, [
                                      _c("td", [
                                        _vm._v(_vm._s(item.event_date))
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getUsername(
                                              item.user,
                                              item.impersonator,
                                              item.is_system_changed
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translate(
                                              "entity_logger.types." + item.type
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      item.is_overproduction_update
                                        ? _c("td", [
                                            _vm._v(_vm._s(item.object_name))
                                          ])
                                        : _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translate(
                                                  "entities." + item.object_name
                                                )
                                              ) +
                                                "(" +
                                                _vm._s(item.object_id) +
                                                ")"
                                            )
                                          ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            "max-width": "70%",
                                            "min-width": "50%"
                                          }
                                        },
                                        [
                                          item.data
                                            ? _c(
                                                "table",
                                                {
                                                  staticClass:
                                                    "data-table custom-striped"
                                                },
                                                [
                                                  _c("thead", [
                                                    _c("tr", [
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.translate(
                                                              "entity_logger.list.attribute"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.translate(
                                                              "entity_logger.list.old_value"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.translate(
                                                              "entity_logger.list.new_value"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "tbody",
                                                    _vm._l(item.data, function(
                                                      data,
                                                      key
                                                    ) {
                                                      return _c(
                                                        "tr",
                                                        { key: key },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "attribute-column"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(key)
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          data.old !==
                                                            undefined ||
                                                          data.old === null
                                                            ? _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "data-column"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        data.old
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "data-column"
                                                                },
                                                                [_vm._v("---")]
                                                              ),
                                                          _vm._v(" "),
                                                          data.new !==
                                                            undefined ||
                                                          data.new === null
                                                            ? _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "data-column"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        data.new
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "data-column"
                                                                },
                                                                [_vm._v("---")]
                                                              )
                                                        ]
                                                      )
                                                    }),
                                                    0
                                                  )
                                                ]
                                              )
                                            : _c("span", [_vm._v("---")])
                                        ]
                                      )
                                    ])
                                  }),
                                  0
                                )
                              ]
                            )
                          ])
                        : !_vm.loading
                        ? _c("span", { staticClass: "no-records" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.translate("entity_logger.list.no_records")
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn btn-default",
                      attrs: { type: "button" },
                      on: { click: _vm.hideHistory }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.translate(
                              "entity_logger.modal.close_button_title"
                            )
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41f60160", { render: render, staticRenderFns: staticRenderFns })
  }
}